import { render, staticRenderFns } from "./UploadMigrationButton.vue?vue&type=template&id=66a40c1c&"
import script from "./UploadMigrationButton.vue?vue&type=script&lang=js&"
export * from "./UploadMigrationButton.vue?vue&type=script&lang=js&"
import style0 from "./UploadMigrationButton.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VFileInput,VForm})
